import { useApolloClient } from '@apollo/client'
import { useCallback } from 'react'
import {
  EntityResolverPersonDocument,
  EntityResolverSearchPersonsDocument,
} from 'generated/resources/graphql'
import buildUrl from 'modules/core/lib/buildUrl'

export const usePersonResolver = () => {
  const client = useApolloClient()

  const person = useCallback(
    async (id: string) => {
      const { data } = await client.query({
        query: EntityResolverPersonDocument,
        variables: { ids: [id] },
      })
      const node = data.employees.employeesConnection.nodes[0]
      if (!node) throw new Error(`Employee with id ${id} not found`)
      return {
        id: node.id,
        firstName: node.firstName,
        lastName: node.lastName,
        avatarUrl: node.access?.avatar ? buildUrl(node.access.avatar) : undefined,
        jobTitle: node.referenceContract?.jobTitle ?? undefined,
      }
    },
    [client]
  )

  const searchPersons = useCallback(
    async (query: string) => {
      const { data } = await client.query({
        query: EntityResolverSearchPersonsDocument,
        variables: { search: query },
      })
      return data.employees.employeesConnection.nodes.map((node) => ({
        id: node.id,
        firstName: node.firstName,
        lastName: node.lastName,
        avatarUrl: node.access?.avatar ? buildUrl(node.access.avatar) : undefined,
        jobTitle: node.referenceContract?.jobTitle ?? undefined,
      }))
    },
    [client]
  )

  return { person, searchPersons }
}
